export default __webpack_public_path__ + "static/media/manutencao-20.90580d02.svg";